import { useSetAtom } from 'jotai';

import { AudioVideoTroubleshootActionItemWrapper as BaseAudioVideoTroubleshootActionItem } from '../components/help-modal/AudioVideoTroubleshootActionItem';
import { useTheme } from '../hooks';
import { useInitAvailableDevices } from '../session/devices/useDevices';
import { Theme } from '../state';
import { useContactUs } from '../useContactUs';
import { HelpModal, HelpModalProps } from './HelpModal';
import { VisitorDrawerState, visitorDrawerStateAtom } from './state';
import { useRecordProviderNoShowReportCallback } from './waiting-room/useRecordProviderNoShowReportCallback';

export function HelpModalWrapper(
  props: Omit<
    HelpModalProps,
    | 'audioVideoTroubleshootActionItem'
    | 'isPastNoShowThreshold'
    | 'clientJoinedAfterWindowToReport'
    | 'recordProviderNoShowAndRedirect'
    | 'isDarkTheme'
    | 'contactUsUrl'
  >,
) {
  useInitAvailableDevices();
  const { pageUrl } = useContactUs();
  const { theme } = useTheme();
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const openSettings = () => {
    props.onClose();
    setDrawerState(VisitorDrawerState.SETTINGS);
  };
  const { isPastNoShowThreshold, clientJoinedAfterWindowToReport, recordProviderNoShowAndRedirect } =
    useRecordProviderNoShowReportCallback();

  return (
    <HelpModal
      isDarkTheme={theme === Theme.DARK}
      contactUsUrl={pageUrl}
      isPastNoShowThreshold={isPastNoShowThreshold}
      clientJoinedAfterWindowToReport={clientJoinedAfterWindowToReport}
      recordProviderNoShowAndRedirect={recordProviderNoShowAndRedirect}
      audioVideoTroubleshootActionItem={<BaseAudioVideoTroubleshootActionItem onOpenSettings={openSettings} />}
      {...props}
    />
  );
}
